const MOCK_DELAY = 300
const PAGE_SIZE = 2

const patients = [
  {
    patient_code: 'mock-patient-001',
    name: '王小明',
    phone: '0912345678',
    birthday: '1991-05-12'
  },
  {
    patient_code: 'mock-patient-002',
    name: '王小美',
    phone: '0922333444',
    birthday: '1985-11-30'
  },
  {
    patient_code: 'mock-patient-003',
    name: '陳美玲',
    phone: '',
    birthday: '1978-02-18'
  },
  {
    patient_code: 'mock-patient-004',
    name: '林志豪',
    phone: '0975123456',
    birthday: ''
  }
]

function delayedResolve(data) {
  return new Promise(resolve => {
    setTimeout(() => resolve({data}), MOCK_DELAY)
  })
}

function delayedReject(message) {
  return new Promise((resolve, reject) => {
    setTimeout(() => reject({
      response: {
        data: {messages: message}
      }
    }), MOCK_DELAY)
  })
}

function formatLocalDate(date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function addDays(baseDate, offset) {
  const [year, month, day] = baseDate.split('-').map(Number)
  const date = new Date(Date.UTC(year, month - 1, day + offset))
  return date.toISOString().slice(0, 10)
}

function dateTime(baseDate, offset, time) {
  return `${addDays(baseDate, offset)}T${time}:00+08:00`
}

function appointment({patientCode, index, baseDate, offset, start, end, status, doctorName = '陳醫師'}) {
  return {
    reserve_no: `mock-reserve-${patientCode}-${index}`,
    start_at: dateTime(baseDate, offset, start),
    end_at: dateTime(baseDate, offset, end),
    attend_status: String(status),
    clinic_name: 'Dent&Co 測試診所',
    doctor_name: doctorName,
    doctor_title: '牙醫師'
  }
}

function buildAppointments(patientCode, baseDate) {
  if (patientCode === 'mock-patient-001') {
    const future = [
      [3, '09:00', '09:30', 0, '陳醫師'],
      [7, '14:00', '14:30', 0, '林醫師'],
      [14, '10:30', '11:00', 0, '陳醫師'],
      [21, '16:00', '16:30', 0, '張醫師'],
      [28, '11:00', '11:30', 0, '林醫師'],
      [35, '15:30', '16:00', 0, '陳醫師']
    ].map(([offset, start, end, status, doctorName], index) => appointment({
      patientCode,
      index: `future-${index + 1}`,
      baseDate,
      offset,
      start,
      end,
      status,
      doctorName
    }))
    const past = [
      [-5, '09:30', '10:00', 1],
      [-20, '13:30', '14:00', -1],
      [-35, '11:00', '11:30', 4],
      [-50, '15:00', '15:30', 1],
      [-65, '10:00', '10:30', 1],
      [-80, '14:30', '15:00', 5]
    ].map(([offset, start, end, status], index) => appointment({
      patientCode,
      index: `past-${index + 1}`,
      baseDate,
      offset,
      start,
      end,
      status
    }))

    return {future, past}
  }

  if (patientCode === 'mock-patient-002') {
    return {
      future: [],
      past: [appointment({
        patientCode,
        index: 'past-1',
        baseDate,
        offset: -2,
        start: '15:00',
        end: '15:30',
        status: 1,
        doctorName: '林醫師'
      })]
    }
  }

  if (patientCode === 'mock-patient-003') {
    return {
      future: [appointment({
        patientCode,
        index: 'future-1',
        baseDate,
        offset: 1,
        start: '18:00',
        end: '18:30',
        status: 0,
        doctorName: '張醫師'
      })],
      past: []
    }
  }

  return {future: [], past: []}
}

function appointmentSummary(patientCode, baseDate) {
  const {future, past} = buildAppointments(patientCode, baseDate)
  if (future.length) {
    return {
      relation: 'next',
      start_at: future[0].start_at
    }
  }
  if (past.length) {
    return {
      relation: 'previous',
      start_at: past[0].start_at
    }
  }
  return null
}

function normalizeKeyword(value) {
  return String(value || '').trim().toLowerCase().replace(/[\s/.-]/g, '')
}

function rocBirthday(birthday) {
  if (!birthday) return ''
  const [year, month, day] = birthday.split('-')
  return `${Number(year) - 1911}${month}${day}`
}

function matchedPatients(keyword) {
  const normalizedKeyword = normalizeKeyword(keyword)
  if (normalizedKeyword === normalizeKeyword('查無資料')) return []

  const matches = patients.filter(patient => [
    patient.name,
    patient.phone,
    patient.birthday,
    rocBirthday(patient.birthday)
  ].some(value => normalizeKeyword(value).includes(normalizedKeyword)))

  // 暫時用於畫面驗收：未命中 mock 關鍵字時仍回傳完整樣本。
  return matches.length ? matches : patients
}

export function searchReservePatientsMockAPI(data = {}) {
  if (normalizeKeyword(data.keyword) === normalizeKeyword('模擬錯誤')) {
    return delayedReject('模擬病患搜尋失敗')
  }

  const baseDate = formatLocalDate()
  const matched = matchedPatients(data.keyword)
  const start = Number(String(data.cursor || '').replace('mock-cursor-', '')) || 0
  const page = matched.slice(start, start + PAGE_SIZE).map(patient => ({
    ...patient,
    appointment_summary: appointmentSummary(patient.patient_code, baseDate)
  }))
  const nextStart = start + PAGE_SIZE
  const hasMore = nextStart < matched.length

  return delayedResolve({
    data: page,
    meta: {
      base_date: baseDate,
      has_more: hasMore,
      next_cursor: hasMore ? `mock-cursor-${nextStart}` : null
    }
  })
}

export function getReservePatientAppointmentsMockAPI(patientCode, params = {}) {
  const baseDate = params.base_date || formatLocalDate()
  const {future, past} = buildAppointments(patientCode, baseDate)

  return delayedResolve({
    future,
    past,
    appointment_summary: appointmentSummary(patientCode, baseDate)
  })
}
